<template>
    <sa-page-layout :btnBackVisible="false" :btnEditVisible="false" :linkback="linkback" :linkedit="linkedit"
        :pathResource="pathResource" :showModalLoading="showModalLoading" :btnPrintVisible="false"
        :linkPrintData="linkPrintData">
        <template slot="toolbar"> </template>
        <template slot="table-body">
            <SaccSarrComponent ref="cmpSaccSarrComponent" @beforeLoadData="onBeforeloadData"
                @afterLoadData="onAfterLoadData" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import SaccSarrComponent from "../components/SaccSarrComponent.vue";

export default {
    components: { SaPageLayout, SaccSarrComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            btnNewVisible: false,
            pathResource: "/rsaaccettazioni",
            id: null,
            btnEditVisible: true,
            linkedit: null,
            linkback: "/flussi",
            linkPrintData: "",
            showModalLoading: false,
            listKey: 0,
        };
    },
    // mounted() {
    //     let me = this;
    //     me.id = this.$route.params.id;
    //     me.linkedit = "/rsaaccettazione/edit/" + me.id;
    //     me.linkPrintData = "/rsaaccettazioni/print/" + me.id;
    //     this.$refs.cmpAnagraficaRegionaleTest.setId(me.id);
    // },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeloadData() {
            let me = this;
            me.showModalLoading = true;
        },
        loadStampeReport() {
            let me = this;
            // me.printData = {};

            me.loadDataResources(me.pathResource + "/printdata/" + me.id, null, me.resultResponseStampa, me.resultErrorStampa);
        },
        resultResponseStampa(response) {
            let me = this;
            me.reportName = response.data.data.reportName;
            me.printData = response.data.data;

            me.$refs.cmpPrint.print(response.data.data);
        },
        resultErrorStampa(error) {
            console.log(error);
        },
    },
};
</script>
<style></style>
